module.exports = __webpack_public_path__ + "07_medium_gray.b79c92df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_medium_gray.png
// module id = 0wY3
// module chunks = 0